import { render } from "./PdmClientIndex.vue?vue&type=template&id=437561d0&scoped=true"
import script from "./PdmClientIndex.vue?vue&type=script&lang=js"
export * from "./PdmClientIndex.vue?vue&type=script&lang=js"

import "./PdmClientIndex.vue?vue&type=style&index=0&id=437561d0&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437561d0"]])

export default __exports__